import React, { FC } from 'react';
import Button from '../../base/ButtonBase';
import styles from './styles';

export type ContainedButtonProps = {
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;

  /**
   * onPress handler
   */
  onPress: (e: any) => void;

  /**
   * Style of the text
   */
  textStyle?: any;

  /**
   * Title of the button
   */
  title: string;

  /**
   * Style - any general style over ride
   */
  style?: any;

  /**
   * An alternative to passing a onPress handler you can pass a url
   */
  url?: string;
};

export const ContainedButton: FC<ContainedButtonProps> = (props) => {
  const { disabled, onPress, style, title, url } = props;

  return (
    <Button
      containerStyle={[styles.container, style]}
      disabled={disabled}
      disabledContainerStyle={styles.disabledStyle}
      hoverTextStyle={styles.hoverTextStyle}
      hoverStyle={styles.hoverStyle}
      onPress={onPress}
      textStyle={styles.text}
      title={title}
      url={url}
    />
  );
};

export default ContainedButton;
